// src/i18n/locales/en.js
export const en = {
  actions: {
  workshop: "Free workshop {{date}} ✨",
  buy: "Buy",
  sell: "Sell",
  send: "Send",
  deliver: "Deliver",
  journeys: "Find inexpensive journeys",
  books: "Find something to read",
},
event: {
  title: "Sell faster on web",
  free: "Free workshop",
  timePrefix: "at",
  snacks: "Snacks provided",
  description:
    "Photos, pricing and timing – plus how to use AI to create the same listing on Vinted and Tori at once.",
  addToCalendar: "Save to calendar",
  googleCalendar: "Google Calendar",
  reminderTitle: "Get an email reminder",
  reminderHint:
    "Leave your email and we'll send you a reminder and the participation details before the event.",
  reminderSuccess:
    "Thanks! We'll send you a reminder and the participation details before the event.",
  reminderError: "Signup failed. Please try again in a moment.",
  reminderCta: "Get a reminder",
  emailLabel: "Email",
  invalidEmail: "Please check the email address",
  consentLabel:
    "My email may only be used to send the reminder and participation details for this event.",
  consentRequired: "Please accept email storage so we can send the reminder",
},
  
  // ============================================
  // COMMON / SHARED
  // ============================================
  common: {
      changeImage: "Change image",

    clear: "Clear",
    copy: "Copy",
    copied: "Copied",
    deselectAll: "Deselect all",
    total: "Total",
    actions: "Actions",
    reset: "Reset",
    done: "Done",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    back: "Back",
    next: "Next",
    gotIt: "Got It!",
    apply: "Apply",
    showLess: "Show Less",
    showMore: "Show all",
    creating: "Creating...",
    or: "or",
    add: "Add",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    optional: "Optional"
  },
  // ============================================
  // LISTING (Create/Review Listings)
  // ============================================
  listing: {
    createMore: "Create more",
    viewListings: "View listings",
    successTitle: "Listing created",
    description: "Description of the item",
    successDescription: 'Your listings have been created successfully, you can view and edit them in your profile.',
    addMore: "Add More Listings",
    dragToGroup: "Drag to group listings",
    organizePhotos: "Organize your photos by dragging and dropping them",
    continue: "Continue to Review",
    reviewListings: "Review Listings",
    image: "Images",
    title: "Title",
    category: "Category",
    price: "Price",
    actions: "Actions",
    creating: "Creating...",
    createListings: "Create listing",
    "groupName": "Group name (optional)",
    "imageName": "Image name (optional)",
    "imageCount": "{{count}} images",
    "dragPhotosHere": "Drag photos here",
    "images": "Images",
    "coverImage": "Cover",
    "imageUploaded": "Uploaded",
    "noImage": "No image",
    "condition": "Condition",
    "bookInfo": "Book Information",
    "aiPriceEstimate": "AI Price Estimate",
    "reasoning": "Reasoning",
    "brand": "Brand",
    "detectedInfo": "AI Detected Info",
    "color": "Color",
    "material": "Material",
    "confidence": "Confidence"
  },
  // ============================================
  // HEADER & NAVIGATION
  // ============================================
  header: {
    title: "Tech Store",
    home: "Home",
    products: "Products"
  },
  // ============================================
  // MODE (Buy/Sell/Rent)
  // ============================================
  mode: {
    buy: "Buy",
    sell: "Sell",
    rent: "Rent"
  },
  // ============================================
  // TYPE (Product/Service)
  // ============================================
  type: {
    product: "Product",
    products: "Products",
    service: "Service",
    services: "Services"
  },
  // ============================================
  // AUTHENTICATION
  // ============================================
  auth: {
    loginRequired: "Please login to continue",
    login: "Login",
    createAccount: "Create Account",
    email: "Email",
    password: "Password",
    signUp: "Sign Up",
    loginSuccess: "Login successful",
    accountCreated: "Account created"
  },
  // ============================================
  // SEARCH
  // ============================================
  search: {
    suggestions: "Suggestions",
    uploadImages: 'Please wait...',
    uploadingImages: 'Uploading images...',
    placeholder: "Search for anything...",
    placeholderBuy: "Write what you need",
    placeholderBuyMobile: "What do you need?",
    placeholderSell: "What would you like to sell? Or take a photo",
    placeholderSellMobile: "What are you offering?",
    placeholderRent: "What would you like to lend? Or take a photo",
    placeholderBuyService: "What service do you need?",
    placeholderSellService: "Describe the service you offer...",
    buy: "Buy",
    sell: "Sell",
    products: "Products",
    services: "Services",
    resultsFor: "Search results for",
    productsFound: "products found",
    noResults: "No products found",
    tryDifferent: "Try searching with different keywords",
    locationWarning: "Set your location for better results",
    recentSearches: "Recent searches",
    suggestedCategory: "Suggested category:",
    suggestedCategoryHint: "Tap to search more shops in this category",
    allProductsLoaded: "All products loaded",
    otherCategories: "Other categories:",
    suggestedCategoryPrompt: "Tap to search more products in this category",
  
    suggestedCategory: "Suggested category:",
    otherCategories: "Other categories:",
    emptyStateBuy: "Write to see suggestions",
    emptyStateSell: "Write or add photo to see suggestions",
    // Image search

    selectImage: "Select an image",
    compressingImages: "Compressing images...",
    cropping: "Cropping...",
    imageCompressionError: "Couldn't process the images. Please try again.",
    captureError: "Couldn't take the photo. Please try again.",
    cropError: "Couldn't crop the image. Please try again.",
    imageSearch: "Search by image",
    addImages: "Add Images",
    cropImage: "Crop Image",
    search: "Search",
    analyzing: "Analyzing...",
    imageSearchFailed: "Failed to search with image. Please try again.",
    selectedImages: "Selected images",
    useImages: "Use Images",
    maxImagesReached: "Maximum number of images reached",
    dragDropImages: "Drag & drop images here",
    orSelectFiles: "or click to select files",
    takePhoto: "Take Photo",
    uploadFromDevice: "Upload",
    maxImagesInfo: "Max 5 images • PNG, JPG, WEBP",
    cameraError: "Could not access camera. Please check permissions.",
    cameraComingSoon: "Image search coming soon!",
    cropSize: "Crop Size",
    zoom: "Zoom",
    applyCrop: "Apply Crop",
    deliveryOptionsBuy: "When do you need it?",
    // Journey search
    journey: {
      from: "From",
      fromPlaceholder: "City or station",
      to: "To",
      toPlaceholder: "City or station",
      date: "Date",
      selectDate: "Select date",
      passengers: "Passengers",
      search: "Search"
    },
    // Logistics search
    logistics: {
      pickup: "Pickup",
      pickupPlaceholder: "Pickup location",
      dropoff: "Drop-off",
      dropoffPlaceholder: "Drop-off location",
      pickupDate: "Pickup date"
    }
  },
  // ============================================
  // DELIVERY
  // ============================================

  // ============================================
  // LOCATION
  // ============================================
  location: {
    notSet: "Location not set",
    generalLocation: "From Finland",
    locationRecommended: "Location",
    setLocation: "Set Location",
    resultsForLocation: "Results for area",
    noOptions: "No locations found",
    deliverTo: "Deliver to",
    description: "Enter a location or use automatic detection",
    enterLocation: "Enter Location",
    placeholder: "e.g., New York, NY",
    cancel: "Cancel",
    save: "Save",
    detectHint: "Click the location icon to detect your current location automatically",
    notSupported: "Geolocation is not supported by your browser",
    permissionDenied: "Location access was denied. Please enable location permissions.",
    unavailable: "Location information is unavailable.",
    timeout: "Location request timed out.",
    error: "Could not get your location",
    fetchError: "Could not fetch location name"
  },
  // ============================================
  // ADDRESS
  // ============================================
  address: {
    editAddress: "Edit address",
    mainAddress: "Address",
    streetAddress: "Street address",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
    addressDetails: "Address details",
    detailsHelp: "Giving exact address details helps us deliver your order faster.",
    locationType: "Location type",
    house: "House",
    apartment: "Apartment",
    office: "Office",
    other: "Other",
    entrance: "Entrance / Staircase",
    floor: "Floor",
    howToGetIn: "How do we get in?",
    doorbell: "Doorbell / Intercom",
    doorCode: "Door code",
    doorOpen: "Door is open",
    accessOther: "Other (tell us how)",
    enterDoorCode: "Door code",
    additionalInstructions: "Other instructions for the courier",
    instructionsPlaceholder: "e.g. Ring the doorbell twice",
    optional: "Optional",
    addressLabel: "Address label",
    labelHelp: "Labelling addresses helps you to choose between them. Choose 'Other' to create your own custom label.",
    home: "Home",
    work: "Work",
    customLabel: "Custom label",
    customLabelPlaceholder: "e.g. Mom's place",
    coordinates: "Location coordinates",
    cancel: "Cancel",
    save: "Save address"
  },
  // ============================================
  // CATEGORIES
  // ============================================
  categories: {
    tickets: 'Tickets',
    all: "All Categories",
    any: "Any Category",
    details: "Category",
    subcategories: "Subcategories",
    browseAll: "Browse All",
    // Product categories
    fuel: "Fuel",
    flower: "Flowers",
    groceries: "Groceries",
    restaurant: "Restaurant",
    food: "Food & Dining",
    electronics: "Electronics",
    clothing: "Clothing & Fashion",
    homeGarden: "Home & Garden",
    beauty: "Beauty & Personal Care",
    sports: "Sports & Outdoors",
    books: "Books",
    toys: "Toys & Games",
    health: "Health & Wellness",
    automotive: "Automotive",
    pets: "Pet Supplies",
    office: "Office Supplies",
    other: "Other",
    // Surplus/outlet
    "home-garden": "Home & Garden",
    "surplus-restaurant": "Surplus Restaurant",
    "outlet-electronics": "Outlet Electronics",
    "surplus-groceries": "Surplus Groceries",
    "surplus-flower": "Surplus Flowers",
    // Product subcategories
    product: {
      location: "Location",
      askSeller: 'Send message to merchant',
      makeOffer: 'Send offer to merchant',
      flowers: "Flowers & Plants",
      food: "Food & Groceries",
      electronics: "Electronics",
      furniture: "Furniture",
      vehicles: "Vehicles",
      other: "Other Products"
    },
    // Service categories (nested under categories for organization)
    service: {
      repair: "Repair & Maintenance",
      home_services: "Home Services",
      professional: "Professional Services",
      personal: "Personal Care",
      education: "Education & Tutoring",
      other: "Other Services"
    }
  },
  // ============================================
  // SERVICES
  // ============================================
  services: {
    journeyTickets: "Journey Tickets",
    "journey-tickets": "Journey Tickets",
    journeyTicketsDesc: "Book taxis, trains, buses, flights and carpools",
    health: "Health Services",
    healthDesc: "Doctors, pharmacies, and healthcare",
    logistics: "Logistics",
    logisticsDesc: "Delivery, moving, and storage services",
    entertainment: "Entertainment",
    entertainmentDesc: "Music, events, and fun activities",
    homeServices: "Home Services",
    homeServicesDesc: "Repairs, cleaning, and maintenance",
    education: "Education",
    educationDesc: "Tutoring, classes, and courses",
    beauty: "Beauty Services",
    beautyDesc: "Hair, nails, makeup, and spa",
    photography: "Photography",
    photographyDesc: "Photo and video services",
    petServices: "Pet Services",
    petServicesDesc: "Grooming, walking, and vet care",
    childcare: "Childcare",
    childcareDesc: "Babysitting and daycare services",
    repairs: "Repairs",
    repairsDesc: "Fix appliances, electronics, and vehicles"
  },
  // ============================================
  // SERVICE (single service details)
  // ============================================
  service: {
    description: "Description",
    details: "Service Details",
    location: "Location",
    availability: "Availability",
    website: "Website",
    phone: "Phone",
    priceOnRequest: "Price on request",
    hour: "hour",
    day: "day",
    from: "From",
    book: "Book",
    contact: "Contact",
    provider: "Provider",
    openToday: "Open",
    closedToday: "Closed"
  },
  // ============================================
  // SUBCATEGORIES
  // ============================================
  subcategories: {
    all: "All",
    popular: "Popular",
    new: "New Arrivals",
    deals: "Best Deals",
    journey: {
      taxi: "Taxi",
      train: "Train",
      bus: "Bus",
      flight: "Flight",
      carpool: "Carpool"
    },
    health: {
      generalDoctor: "General Doctor",
      pharmacy: "Pharmacy",
      vaccination: "Vaccination",
      mentalHealth: "Mental Health",
      physiotherapy: "Physiotherapy"
    },
    logistics: {
      packageDelivery: "Package Delivery",
      storage: "Storage",
      moving: "Moving Services",
      freight: "Freight"
    },
    entertainment: {
      liveMusic: "Live Music",
      movies: "Movies",
      events: "Events",
      dj: "DJ Services"
    },
    home: {
      painting: "Painting",
      electrical: "Electrical",
      plumbing: "Plumbing",
      gardening: "Gardening",
      cleaning: "Cleaning",
      furniture: "Furniture Assembly"
    },
    education: {
      language: "Language Classes",
      tutoring: "Tutoring",
      artClasses: "Art Classes",
      coding: "Coding Classes"
    },
    beauty: {
      hair: "Hair Styling",
      nails: "Nail Services",
      makeup: "Makeup",
      spa: "Spa & Massage"
    },
    photography: {
      event: "Event Photography",
      video: "Videography",
      portrait: "Portrait",
      commercial: "Commercial"
    },
    pet: {
      grooming: "Pet Grooming",
      walking: "Dog Walking",
      vet: "Veterinary",
      training: "Pet Training"
    },
    childcare: {
      babysitting: "Babysitting",
      daycare: "Daycare",
      tutoring: "Kids Tutoring"
    },
    repairs: {
      appliance: "Appliance Repair",
      electronics: "Electronics Repair",
      car: "Car Repair"
    },
    fuel: {
      95: "95",
      98: "98",
      diesel: "Diesel"
    },
    electronics: {
      outlet: "Outlet Electronics",
      phones: "Phones & Tablets",
      computers: "Computers & Laptops",
      accessories: "Accessories"
    },
    restaurant: {
      surplus: "Surplus Food",
      fastFood: "Fast Food",
      fineDining: "Fine Dining",
      cafe: "Café & Coffee"
    },
    groceries: {
      surplus: "Surplus Groceries",
      fresh: "Fresh Produce",
      frozen: "Frozen Foods",
      beverages: "Beverages"
    }
  },
  // ============================================
  // FILTERS
  // ============================================
  filters: {
    marketplace: 'Marketplace',
    sourceCount: "{{enabled}} of {{total}}",
    sourceOptions: {
      all: "Everywhere",
      secondHand: "Second-hand",
      new: "New",
      library: "Library",
      cheap: "Cheap"
    },
    selectSource: 'Select source',
    sourceType: 'Source type',
    searchSites: 'Sites to source',
    selectSitesHelper: 'More sites will be added in the future, let us know what you need',
    allServices: "All Services",
    categories: "Categories",
    availability: "Availability",
    priceType: "Price type",
    allCategories: "All Categories",
    location: "Location",
    locationAny: "Anywhere",
    category: "Category",
    categoryAny: "All categories",
    delivery: "Delivery",
    deliveryAny: "Any speed",
    subcategory: "Subcategory",
    quality: "Quality",
    type: "Type",
    all: "All",
    allFilters: "All filters",
    sort: "Sort",
    any: "Any",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    price: "Price",
    reset: "Reset Filters",
    clear: "Clear",
    selectCategory: "Select category",
    condition: "Condition",
    source: "Source",
    new: "New",
    used: "Used",
    apply: "Apply"
  },
  category: {
    subcategories: "Subcategories",
    details: "Details",
    browseAll: "Browse general"
  },
  categorySelector: {
    title: "Select Category",
    allCategories: "All Categories",
    food: "Food",
    electronics: "Electronics",
    flowers: "Flowers",
    cancel: "Cancel",
    apply: "Apply Filter"
  },
  qualitySelector: {
    title: "Select Quality",
    allQuality: "All Quality",
    new: "New",
    used: "Used",
    cancel: "Cancel",
    apply: "Apply Filter"
  },
  typeSelector: {
    title: "Select Type",
    allTypes: "All Types",
    onSale: "On Sale",
    buying: "Buying",
    lending: "Lending",
    cancel: "Cancel",
    apply: "Apply Filter"
  },
  // ============================================
  // PRODUCT
  // ============================================
  product: {
    location: "Location",
    askSeller: 'Send message to merchant',
    makeOffer: 'Send offer to merchant',
    flowers: "Flowers & Plants",
    food: "Food & Groceries",
    electronics: "Electronics",
    furniture: "Furniture",
    vehicles: "Vehicles",
    other: "Other Products",
    analyse: "Analyse storage",
    // Actions
    add: "Add Product",
    edit: "Edit Product",
    update: "Update Product",
    upload: "List Item",
    addFirst: "Add your first product",
    addToCart: "Add to Cart",
    buyNow: "Buy now",
    viewPickupLocation: "View Pickup Location",
    // Titles
    createSellTitle: "List Item for Sale",
    createRentTitle: "List Item for Rent",
    addSubtitle: "Fill in the details below",
    editSubtitle: "Update product details",
    createSubtitle: "Fill in the details below to list your item",
    listForSale: "List for Sale",
    listForRent: "List for Rent",
    // Sections
    basicInfo: "Basic Information",
    pricing: "Pricing",
    details: "Product Details",
    description: "Description",
    productDetails: "Product Information",
    images: "Images",
    // Fields
    name: "Product Name",
    namePlaceholder: "e.g., iPhone 13 Pro",
    title: "Title",
    titlePlaceholder: "e.g. White Nike Air Max",
    descriptionPlaceholder: "Describe your item in detail...",
    price: "Price",
    pricePerDay: "Price per Day",
    quantity: "Quantity",
    category: "Category",
    subcategory: "Subcategory",
    size: "Size",
    condition: "Condition",
    storage: "Storage",
    // Images
    uploadImages: "Click to upload images",
    uploadPhotos: "Upload photos",
    uploadingImages: "Uploading images...",
    uploadPhotosHint: "Add photos to get more interest (optional)",
    imageHint: "JPG, PNG up to 5MB",
    mainImage: "Main",
    maxImagesError: "Maximum {{max}} images allowed",
    fileTooLarge: "File is too large (max 5MB)",
    invalidFileType: "Invalid file type",
    noImage: "No image available",
    // Status messages
    createSuccess: "Product created successfully! Redirecting...",
    addSuccess: "Product added successfully!",
    updateSuccess: "Product updated successfully!",
    deleteSuccess: "Product deleted successfully!",
    createError: "Failed to create product",
    saveError: "Failed to save product",
    deleteError: "Failed to delete product",
    // Validation
    nameRequired: "Product name is required",
    categoryRequired: "Category is required",
    priceRequired: "Valid price is required",
    // Delete confirmation
    deleteConfirm: "Delete Product?",
    deleteWarning: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    // Other
    moreOptions: "More options",
    fastDelivery: "Fast delivery",
    robotSeller: "Robot Merchant",
    type: "Type",
    seller: "Seller",
    memberSince: "Member since",
    posted: "Posted",
    // Conditions
    conditions: {
      new: "New",
      like_new: "Like New",
      good: "Good",
      fair: "Fair",
      poor: "Poor"
    },
    // Status
    status: {
      label: "Status",
      available: "Available",
      sold: "Sold",
      reserved: "Reserved",
      unavailable: "Unavailable",
      hidden: "Hidden"
    }
  },
  // ============================================
  // CONDITION (standalone)
  // ============================================
  condition: {
    new: "New",
    likeNew: "Like New",
    good: "Good",
    fair: "Fair",
    poor: "Poor"
  },
  // ============================================
  // STATUS (standalone)
  // ============================================
  status: {
    available: "Available",
    reserved: "Reserved",
    hidden: "Hidden",
    sold: "Sold"
  },
  // ============================================
  // SIZE
  // ============================================
  size: {
    small: "Small",
    medium: "Medium",
    large: "Large",
    xl: "Extra Large"
  },
  // ============================================
  // PRODUCTS (list page)
  // ============================================
  products: {
    "searchPlaceholder": "Search products...",
    "emptyState": {
      "title": "Enter a search to get started",
      "description": "Search for products, browse by category, or explore different sources to find what you're looking for."
    },
    "noResults": {
      "title": "No products found"
    },
    title: "Our Products",
    addToCart: "Add to Cart",
    viewDetails: "View Details",
    backToProducts: "Back to Products",
    notFound: "Product not found",
    categories: {
      Audio: "Audio",
      Wearables: "Wearables",
      Accessories: "Accessories",
      Peripherals: "Peripherals"
    }
  },
  // ============================================
  // PRODUCT REQUEST
  // ============================================
  productRequest: {
    buttonText: "Request Product",
    title: "Request a Product",
    drawerTitle: "Request Product",
    cardTitle: "Can't find it?",
    cardDescription: "Request any product and we'll find it for you",
    requestButton: "Request",
    promise: "We'll find it and notify you when it's available!",
    description: "Tell us what product you're looking for and where we can find it.",
    cantFind: "Can't find what you're looking for?",
    helpText: "Let us know and we'll add it to our marketplace within 24 hours.",
    imageHint: "Tell us what you're looking for",
    // Fields
    name: "Product name",
    productName: "Product Name",
    namePlaceholder: "e.g. iPhone 15 Pro Max",
    productNamePlaceholder: "e.g., Nike Air Max 90",
    productUrl: "Product URL",
    urlHelper: "Link to the product on another website",
    descriptionLabel: "Description (optional)",
    additionalInfo: "Additional Information",
    additionalInfoPlaceholder: "Any specific details, size, color, etc.",
    descriptionPlaceholder: "Color, size, specific model...",
    whereToFind: "Where can we find it?",
    website: "Website",
    location: "Store / Location",
    locationPlaceholder: "e.g. Stockmann Helsinki",
    // Actions
    cancel: "Cancel",
    submit: "Submit Request",
    successMessage: "Thank you! We'll notify you when it's available.",
    errors: {
      nameRequired: "Product name is required",
      urlRequired: "Product URL is required",
      invalidUrl: "Please enter a valid URL",
      sourceRequired: "Please provide a website or location"
    }
  },
  // ============================================
  // SERVICE REQUEST
  // ============================================
  serviceRequest: {
    drawerTitle: "Request Service",
    cardTitle: "Need a service?",
    cardDescription: "Request any service and we'll find it for you",
    requestButton: "Request",
    promise: "We'll help you find the right service provider",
    imageHint: "Tell us what service you need",
    cantFind: "Can't find the service you need?",
    helpText: "Let us know and we'll help you find it.",
    // Fields
    name: "Service name",
    namePlaceholder: "e.g. Home cleaning",
    description: "Description (optional)",
    descriptionPlaceholder: "What do you need help with?",
    whereToFind: "Where can we find this service?",
    website: "Website",
    location: "Location / Area",
    locationPlaceholder: "e.g. Helsinki area",
    // Actions
    submit: "Submit",
    sourceRequired: "Please provide a website or location",
    successMessage: "Request submitted! We'll help you find the right provider.",
    errors: {
      nameRequired: "Service name is required",
      invalidUrl: "Please enter a valid URL"
    }
  },
  // ============================================
  // STORAGE
  // ============================================
  storage: {
    createStorage: "Create Storage",
    chooseCreationType: "Choose how you want to create your storage",
    importFromVinted: "Import from Vinted",
    vintedDescription: "Easily import your existing Vinted listings to create a storage",
    manual: "Manual Creation",
    manualDescription: "Create a storage from scratch and add products to it",
    selectedStorage: "Selected storage",
    change: "Change",
    yourStorages: "Your Storages",
    create: "Create Storage",
    update: "Update Storage",
    basicInfo: "Basic Information",
    name: "Storage Name",
    namePlaceholder: "e.g., Main Warehouse",
    postalCode: "Postal Code",
    address: "Address",
    addressPlaceholder: "Street address",
    city: "City",
    cityPlaceholder: "e.g., Helsinki",
    deliveryOptions: "Delivery Options",
    noDeliveryOptions: "No delivery options",
    operatingDays: "Operating Days",
    daysPerWeek: "{{count}} days per week",
    productsInStorage: "Products in Storage",
    noProducts: "No products in this storage yet",
    openingHours: "Opening Hours",
    cutoff: "Cutoff",
    itemCount: "{{count}} items",
    locationNotSet: "Location not set",
    noStorages: "No storages yet",
    createFirst: "Create your first storage to start selling!",
    createSuccess: 'Storage "{{name}}" created successfully!',
    createError: "Failed to create storage. Please try again."
  },
  // ============================================
  // DAYS
  // ============================================
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  // ============================================
  // CART
  // ============================================
  cart: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    total: "Total",
    checkout: "Checkout",
    each: "each",
    quantity: "Quantity"
  },
  // ============================================
  // CHECKOUT
  // ============================================
  checkout: {
    whenPickingUp: "Select time for pickup",
    confirmPickup: "Confirm pickup",
    addToCalendar: "Add to calendar",
    pickupTime: "Pickup time",
    pickupLocation: "Pickup location",
    pickupDetails: "Pickup details",
    pickupCode: "Pickup code",
    pickupConfirmationDesc: "Information about pickup",
    pickUpConfirmation: "Pickup confirmed",
    noPickupOptions: "No pickup options available",
    loadingDeliveryOptions: "Loading delivery options...",
    title: "Checkout",
    orderSummary: "Order summary",
    subtotal: "Subtotal",
    delivery: "Delivery",
    pickup: "Pickup",
    continueShopping: "Continue shopping",
    emptyCart: "Your cart is empty",
    groups: "Groups",
    // Delivery
    deliveryMethod: "Delivery method",
    moreOptions: "more delivery options",
    showLess: "Show less",
    selectDeliveryTime: "Select delivery time",
    selectDateFirst: "Select date first, then time slot",
    selectCustomTime: "Please select a delivery date and time",
    deliveryDate: "Delivery date",
    timeSlot: "Time slot",
    estimatedDelivery: "Estimated delivery:",
    deliveryOptions: "Delivery options",
    deliveryAddress: "Delivery address",
    selectDeliveryOption: "Select delivery option",
    noDeliveryOptions: "No delivery options available for this address",
    // Storage
    storage: "Storage",
    multipleStorages: "Multiple storages",
    locations: "Locations",
    editing: "Editing",
    viewAllLocations: "View all locations",
    openingHours: "Opening hours",
    // Payment
    paymentMethod: "Payment",
    morePaymentMethods: "more payment methods",
    proceedToPayment: "Proceed to Payment",
    paymentError: "Failed to create payment. Please try again.",
    paymentInProgress: "Payment in Progress",
    completePaymentInPopup: "Please complete your payment in the popup window",
    cancelPayment: "Cancel Payment",
    mobilepayHint: "Payment will be confirmed with your phone number in the MobilePay app",
    // Phone
    phoneNumber: "Mobile phone number",
    phonePlaceholder: "40 123 4567",
    phoneHelp: "We need your phone number for delivery",
    phoneRequired: "Phone number is required for MobilePay payment",
    // Address
    setAddress: "Set delivery address",
    addressSaveError: "Failed to save address",
    // Medical
    medicalAdvice: {
      title: "Medical Advice",
      question: "Do you want medical advice?"
    },
    // Actions & errors
    confirmOrder: "Confirm order",
    loginRequired: "Please login to continue",
    error: "An error occurred. Please try again."
  },
  // ============================================
  // ORDER CONFIRMATION
  // ============================================
  orderConfirmation: {
    title: "Order Confirmed!",
    message: "Thank you for your purchase. Your order has been successfully placed.",
    continueShopping: "Continue Shopping"
  },
  // ============================================
  // ORDER STATUS
  // ============================================
  orderStatus: {
    loading: "Loading order status...",
    error: "Something went wrong",
    success: "Order Confirmed!",
    successMessage: "Thank you for your purchase. Your order has been successfully placed.",
    cancelled: "Payment Cancelled",
    cancelledMessage: "Your payment was cancelled. No charges were made.",
    pending: "Processing your order",
    pendingMessage: "We've received your order and are confirming it. You'll get a confirmation shortly.",
    orderNumber: "Order number",
    total: "Total",
    items: "items",
    item: "item",
    robotHandling: "Robot is handling your order",
    confirmationEmail: "You'll receive a confirmation email soon",
    viewOrders: "View My Orders"
  },
  // ============================================
  // PAYMENT
  // ============================================
  payment: {
    success: "Payment Successful!",
    successMessage: "Thank you for your order. You will receive a confirmation email shortly.",
    cancelled: "Payment Cancelled",
    cancelledMessage: "Your payment was cancelled. No charges have been made.",
    orderNumber: "Order Number",
    tryAgain: "Try Again",
    continueShopping: "Continue Shopping"
  },
  // ============================================
  // ORDERS
  // ============================================
  orders: {
    title: "Order History",
    noOrders: "No orders yet",
    noOrdersDescription: "Your order history will appear here",
    startShopping: "Start Shopping",
    orderCount: "You have {{count}} order",
    orderCount_plural: "You have {{count}} orders",
    selected: "{{count}} selected",
    printSelected: "Print Selected",
    selectAtLeastOne: "Please select at least one order to print.",
    printWaybillError: "Failed to print waybill. Please try again.",
    printReceiptError: "Failed to print receipt. Please try again.",
    printDocumentsError: "Failed to print documents. Please try again.",
    table: {
      orderId: "Order ID",
      date: "Date",
      products: "Products",
      price: "Price",
      status: "Status",
      actions: "Actions",
      items: "Items",
      itemCount: "{{count}} item",
      itemCount_plural: "{{count}} items"
    },
    status: {
      pending: "Pending",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled",
      confirmed: "Confirmed"
    },
    details: {
      items: "Items",
      contactInfo: "Contact Information",
      phone: "Phone",
      destination: "Destination"
    }
  },
  // ============================================
  // INBOX / MESSAGES
  // ============================================
  inbox: {
    title: "Messages",
    noConversations: "No conversations yet",
    noMessages: "No messages yet",
    noConversationsInTab: "No conversations in this category",
    noInquiriesForProduct: "No inquiries for this product yet",
    messagePlaceholder: "Type a message...",
    startConversation: "Start the conversation by sending a message",
    inquiriesFor: "Inquiries for {{product}}",
    tabs: {
      all: "All",
      purchases: "Purchases",
      inquiries: "Inquiries"
    },
    type: {
      purchase: "Purchase",
      inquiry: "Inquiry"
    }
  },
  // ============================================
  // HOME
  // ============================================
  home: {
    browseServices: "Browse Services",
    quickAccessArea: "Find the best deals in {{area}}",
    browseCategories: "Browse all categories →",
    generalLocation: "Set location",
    browse: "Browse",
    logo: "Marget",
    tagline: "Your personalized marketplace for everything",
    trendingNow: "Trending Now",
    popularCategories: "Popular Categories",
    topServices: "Top Services",
    moreServicesComing: "More service categories coming soon!",
    search: {
      uploadingImages: 'Uploading images...',
      uploadImages: 'Please wait...',
      suggestions: "Suggestions",
      buyProduct: "What do you need?",
      sellProduct: "What are you selling?",
      buyService: "Describe the service you need...",
      sellService: "Describe your service..."
    },
    tips: {
      buyService: "Example: Train tickets from Helsinki to Turku",
      sellService: "Example: Lawn mowing in Helsinki area"
    },
    hero: {
      title: "Welcome to Marget",
      subtitle: "Your personalized marketplace for everything",
      cta: "Shop Now"
    },
    features: {
      title: "Why Choose Us",
      selection: {
        title: "Wide Selection",
        description: "Browse our extensive collection of tech products"
      },
      delivery: {
        title: "Fast Delivery",
        description: "Get your orders delivered within 2-3 business days"
      },
      payment: {
        title: "Secure Payment",
        description: "Shop with confidence using our secure checkout"
      }
    },
    stats: {
      users: "{{count}} Active Users",
      listings: "{{count}} Listings",
      categories: "{{count}} Categories"
    },
    footer: {
      help: "Help",
      privacy: "Privacy",
      terms: "Terms"
    }
  },
  // ============================================
  // USER PAGE
  // ============================================
  userPage: {
    title: "User Profile",
    tabs: {
      profile: "Profile",
      orders: "Orders",
      storages: "Storages",
      settings: "Settings"
    }
  },
  // ============================================
  // PROFILE
  // ============================================
  profile: {
    updateSuccess: "Profile updated successfully!",
    updateError: "Failed to update profile. Please try again.",
    editButton: "Edit Profile",
    cancelButton: "Cancel",
    saveButton: "Save Changes",
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailRequired: "Email is required",
      invalidEmail: "Please enter a valid email address",
      invalidPhone: "Please enter a valid phone number"
    },
    fields: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone Number",
      phonePlaceholder: "+358 40 123 4567",
      optional: "Optional"
    },
    accountInfo: {
      title: "Account Information",
      userId: "User ID",
      postalCode: "Postal Code",
      notSet: "Not set",
      roles: "Roles"
    }
  },
  // ============================================
  // SETTINGS
  // ============================================
  settings: {
    title: "Settings",
    appearance: "Appearance",
    lightMode: "Light",
    darkMode: "Dark",
    systemDefault: "System Default",
    darkModeToggle: "Dark Mode",
    darkModeDescription: "Quick toggle for dark theme",
    currentTheme: "Current theme",
    followingSystem: "following system",
    preferences: "Preferences",
    saveSuccess: "Settings saved successfully!",
    saveError: "Failed to save settings. Please try again.",
    saveButton: "Save Settings",
    userMode: {
      title: "User Mode",
      description: "Select your primary mode of using the platform",
      label: "Mode",
      buyer: "Buyer - Browse and purchase products",
      seller: "Seller - List and sell products",
      lender: "Lender - Rent out your items"
    },
    language: {
      title: "Language & Region",
      label: "Language",
      finnish: "Suomi (Finnish)",
      english: "English",
      swedish: "Svenska (Swedish)"
    },
    notifications: {
      title: "Notifications",
      description: "Manage how you receive notifications",
      push: "Push Notifications",
      pushDescription: "Get notified about order updates and messages",
      email: "Email Updates",
      emailDescription: "Receive promotional emails and updates"
    },
    privacy: {
      title: "Privacy",
      description: "Manage your privacy settings and data preferences",
      manageButton: "Manage Privacy Settings"
    }
  },
  // ============================================
  // THEME
  // ============================================
  theme: {
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    toggle: "Toggle theme"
  },
  // ============================================
  // LANGUAGE
  // ============================================
  language: {
    title: "Language",
    select: "Select language",
    en: "English",
    fi: "Finnish",
    sv: "Swedish"
  },
  // ============================================
  // PHOTO TIPS
  // ============================================
  photoTips: {
    buttonText: "Photo Tips",
    title: "Photo Tips Guide",
    quickTips: "Quick Tips:",
    allDone: "You're all set!",
    readyMessage: "Now you know how to take great photos. Start capturing!",
    reviewAgain: "Review Again",
    lighting: {
      title: "Good Lighting",
      description: "Use natural light when possible. Avoid harsh shadows and dark corners.",
      tips: ["Take photos near a window", "Avoid direct sunlight (too harsh)", "Shoot during daylight hours", "Turn on all room lights if indoors"]
    },
    composition: {
      title: "Good Composition",
      description: "Use the grid to align your subject properly.",
      tips: ["Place item at grid intersections", "Keep horizons level", "Leave some space around the item", "Center important features"]
    },
    background: {
      title: "Clean Background",
      description: "A simple, uncluttered background makes your item stand out.",
      tips: ["Use plain walls or surfaces", "Remove unnecessary objects", "Avoid busy patterns", "Keep it simple and clean"]
    },
    angles: {
      title: "Multiple Angles",
      description: "Show different views to give buyers confidence.",
      tips: ["Front view (main photo)", "Side and back views", "Close-ups of details", "Show scale (with common object)"]
    },
    quality: {
      title: "Image Quality",
      description: "High quality photos build trust with buyers.",
      tips: ["Hold camera steady", "Clean the lens", "Use high resolution", "Avoid zoom (move closer instead)"]
    }
  },
  // ============================================
  // MISC / LEGACY
  // ============================================
  myProfile: "Profile & Settings",
  myOrders: "My Orders",
  logout: "Logout",
  productList: {
    wirelessHeadphones: {
      name: "Wireless Headphones",
      description: "High-quality wireless headphones with noise cancellation"
    },
    smartWatch: {
      name: "Smart Watch",
      description: "Feature-rich smartwatch with health tracking"
    },
    laptopStand: {
      name: "Laptop Stand",
      description: "Ergonomic aluminum laptop stand"
    },
    mechanicalKeyboard: {
      name: "Mechanical Keyboard",
      description: "RGB mechanical keyboard with blue switches"
    },
    wirelessMouse: {
      name: "Wireless Mouse",
      description: "Ergonomic wireless mouse with precision tracking"
    },
    usbcHub: {
      name: "USB-C Hub",
      description: "Multi-port USB-C hub with HDMI and card readers"
    }
  },
  // ============================================
  // LAKI / LEGAL
  // ============================================
  legal: {
    howItWorks: {
      title: "How Marget Works",
      intro: "Marget is a smart commerce ecosystem that helps users discover products and services, compare options, and complete transactions with flexible delivery solutions.",
      roles: {
        title: "User Roles",
        body: "A single Marget account may have multiple roles. Different rules and responsibilities apply depending on how you use the platform.",
        buyer: "Buyer",
        seller: "Seller",
        logistics: "Courier / Logistics Operator"
      },
      marketplace: {
        title: "Marketplace (Buy & Sell)",
        body: "Marget brings together listings from multiple sellers and service providers in one place. Users can browse, compare, and communicate before completing a transaction.",
        bullets: {
          search: "Search and browse products, services, and second-hand listings.",
          compare: "Compare prices, condition or quality, location, and delivery options.",
          contact: "Ask questions and check availability through in-platform messaging.",
          checkout: "Complete transactions and follow order or task status in the app when available."
        }
      },
      delivery: {
        title: "Delivery & Logistics",
        body: "Delivery may be provided by the seller, a third party, or independent couriers operating via Marget. Availability depends on location, time, and capacity.",
        bullets: {
          options: "Options may include pickup, scheduled delivery, or fast delivery where available.",
          availability: "Courier availability and pricing may vary based on demand, distance, and timing.",
          tracking: "Limited location tracking may be used during active delivery tasks to coordinate pickup and drop-off.",
          handover: "Users are responsible for providing accurate address details, access instructions, and safe handover conditions."
        }
      },
      payments: {
        title: "Payments, Pricing & Fees",
        body: "Prices are set by sellers or service providers. Delivery fees, where applicable, depend on delivery method and availability.",
        bullets: {
          pricing: "Listings display prices defined by the seller or service provider.",
          fees: "Marget may charge platform or service fees depending on the product, service, or transaction flow.",
          refunds: "Refunds, cancellations, and disputes depend on the transaction type and applicable terms."
        }
      },
      safety: {
        title: "Trust, Safety & Community",
        body: "Our goal is to keep Marget safe for all users. The platform must be used responsibly and in compliance with applicable laws.",
        bullets: {
          guidelines: "Follow community guidelines and rules regarding prohibited goods and services.",
          reporting: "Report suspicious activity, fraud, or unsafe behavior.",
          enforcement: "Violations may result in restrictions, account removal, or reports to authorities as required by law."
        }
      },
      privacy: {
        title: "Data & Privacy",
        body: "We process only the data necessary to provide, maintain, and improve the service, as well as to ensure safety and reliability.",
        bullets: {
          location: "Location data may be used during active logistics tasks for coordination purposes, but users are not continuously tracked outside such tasks.",
          minimization: "We aim to minimize data collection and limit retention periods.",
          controls: "Users have the right to access, correct, and request deletion of their data in accordance with applicable laws."
        }
      },
      platformRole: {
        title: "Role of Marget",
        body: "Marget provides a technical platform enabling transactions and logistics coordination between users. Marget is not a reseller, transport company, or employer of couriers unless explicitly stated for a specific service."
      }
    }
  },
  cookieConsent: {
    title: "Cookies & Privacy",
    body: 'We use cookies to improve your experience. By clicking "Accept all", you consent to our use of cookies. You can manage your preferences or learn more about how we use cookies.',
    accept: "Accept all",
    reject: "Reject",
    manage: "Manage preferences",
    learnMore: "Learn more"
  },
  delivery: {
    // Existing translations (keep all your existing ones)
    route: "Route",
    origin: "Origin",
    destination: "Destination",
    originHelp: "Pickup address",
    labelsInfo: "Add labels to your package for easier identification",
    selectProductsForLabels: "Select a product to generate labels",
    printLabelsSubtitle: "Print labels to attach to your package",
    printLabels: "Print Labels",
    standard: "1-5 days",
    any: "no preference for delivery time",
    from: "From",
    to: "To",
    bustransport: "Bus Transport",
    noDeliveries: "No deliveries yet",
    printWaybill: "Print Waybill",
    resend: "Resend",
    waybillPrinted: "Waybill downloaded successfully",
    status: {
      active: "Active",
      accepted: "Accepted",
      picked: "Picked Up",
      completed: "Completed",
      cancelled: "Cancelled"
    },
    // Page title
    sendPackage: "Send Package",
    // Location fields
    pickup: "Pickup",
    dropoff: "Delivery",
    size: "Size",
    xl: "Extra Large (90+ kg)",
    // Weight
    weight: "Weight (kg)",
    // Details
    moreDetails: "More Details",
    detailsTitle: "📋 More Details",
    // Distance and duration
    distance: "{{distance}} km",
    distanceWithDuration: "{{distance}} km • {{duration}} min",
    // Buttons and actions
    createDelivery: "Create Delivery",
    createDeliveryWithPrice: "Create Delivery • €{{price}}",
    create: "Create",
    creating: "Creating...",
    creatingDelivery: "Creating...",
    // Estimate
    estimate: "Estimate",
    estimatedPrice: "Estimated Price",
    // Delivery Options
    deliveryOptions: "Delivery Options",
    enterAddressesPrompt: "Enter pickup and delivery addresses to see options",
    // ✅ NEW: Main delivery options
    express: "Express",
    expressDesc: "Fastest delivery available",
    fast: "Fast",
    fastDesc: "Quick delivery service",
    eco: "Eco",
    ecoDesc: "Most affordable options - flexible delivery",
    // ✅ NEW: General
    startingFrom: "Starting from",
    earliestDelivery: "Earliest possible delivery",
    // Option Types (existing)
    busparcel: "Bus Parcel",
    busparcelDesc: "Bus package - click to select",
    custom: "Custom",
    customDesc: "Set your own price",
    customPriceLabel: "Custom Price (€)",
    pickupNow: "Now",
    pickupDate: "Pickup Date",
    today: "Today",
    tomorrow: "Tomorrow",
    pickupTimeModal: {
      title: "Pickup Time",
      time: "Pickup Time"
    },
    // ✅ NEW: Eco modal
    selectEcoOption: "Select Eco Delivery Option",
    busTransport: "Bus Transport",
    busTransportDesc: "Delivery via public transport network",
    regular: "Regular",
    regularDesc: "Standard parcel delivery service",
    bid: "Bid",
    bidDesc: "Set your own price - not guaranteed",
    // ✅ NEW: Regular options modal
    regularOptions: "Regular Delivery Options",
    pickupLocation: "Pickup Location",
    deliveryLocation: "Delivery Location",
    parcelCenter: "Parcel Center",
    homePickup: "Home Pickup",
    homeDelivery: "Home Delivery",
    free: "Free",
    totalPrice: "Total Price",
    // ✅ NEW: Bid modal
    bidTitle: "Set Your Bid",
    bidWarning: "Note: Bidding is not guaranteed to find a courier. Your delivery may not be accepted if the price is too low.",
    yourPrice: "Your Price",
    priceLabel: "Price (€)",
    pickupTime: "Pickup Time (Optional)",
    targetTime: "Target Delivery Time (Optional)",
    date: "Date",
    time: "Time",
    // Special Options
    specialOptions: "Special Options",
    returnParcels: "Return Parcels",
    returnParcelsDesc: "Driver will collect return items",
    temperatureControl: "Temperature Control",
    temperatureControlDesc: "Requires temperature-controlled handling",
    canBeLeftAtDoor: "Can Be Left at Door",
    canBeLeftAtDoorDesc: "Package can be left without signature",
    // My Deliveries
    sendNew: "Send New",
    myDeliveries: "My Deliveries",
    resendNotification: "Delivery details loaded. Update and create new delivery.",
    // Pickup and Delivery Sections
    pickupDetails: "Pickup Details",
    deliveryDetails: "Delivery Details",
    addressDetails: "Address Details",
    optional: "(Optional)",
    senderInformation: "Sender Information",
    recipientInformation: "Recipient Information",
    notSelected: "Not selected",
    // Time
    timeWindow: "Time",
    target: "Target time",
    timeWindowPriceNote: "Defining a time window will add €4 + VAT to the delivery price",
    // VAT
    vat: "incl. VAT",
    // Sender/Recipient
    senderName: "Sender's name",
    senderPhone: "Sender's phone number",
    senderEmail: "Sender's email address",
    recipientName: "Recipient's name",
    recipientPhone: "Recipient's phone number",
    recipientEmail: "Recipient's email address",
    // Form Fields
    form: {
      apartmentNumber: "Apartment Number",
      apartmentPlaceholder: "e.g., 12B",
      floor: "Floor",
      floorPlaceholder: "e.g., 3rd floor",
      buildingName: "Building Name",
      buildingPlaceholder: "e.g., Building A",
      accessCode: "Access Code",
      accessCodePlaceholder: "e.g., #1234*",
      pickupInstructions: "Pickup Instructions",
      pickupInstructionsPlaceholder: "Leave package at reception, ring doorbell twice, etc.",
      deliveryInstructions: "Delivery Instructions",
      deliveryInstructionsPlaceholder: "Leave at door, call upon arrival, etc.",
      name: "Name",
      senderNamePlaceholder: "Sender's name",
      recipientNamePlaceholder: "Recipient's name",
      phone: "Phone Number",
      phonePlaceholder: "+358 40 123 4567",
      email: "Email",
      emailPlaceholder: "example@email.com"
    },
    // Error messages
    errors: {
      selectAddresses: "Select pickup and delivery addresses.",
      selectOption: "Select a delivery option.",
      createFailed: "Error creating delivery."
    },
    // Success messages
    success: {
      created: "Delivery created successfully!"
    },
    // ✅ Items Selection Modal
    selectPackageSize: "Select Package Size",
    packageCategory: "Package Category",
    // Size categories
    small: "Small",
    medium: "Medium",
    large: "Large",
    extraLarge: "Extra Large",
    // Specifications
    specifications: "Specifications",
    maxDimensions: "Max dimensions",
    // Items
    items: "Items",
    item: "Item",
    addItem: "Add Item",
    // Dimensions
    length: "L (cm)",
    width: "W (cm)",
    height: "H (cm)",
    // Size descriptions (for PACKAGE_SIZES config)
    sizeDescriptions: {
      small: {
        example: "Easily carried by hand",
        description: "Letters, documents, small packages"
      },
      medium: {
        example: "Fits in a car trunk",
        description: "Medium boxes, sports equipment"
      },
      large: {
        example: "Fits in a van",
        description: "Large boxes, furniture pieces"
      },
      extraLarge: {
        example: "Fits in a truck",
        description: "Appliances, large furniture"
      }
    },
    busTransportModal: {
      title: "Bus Package",
      departureTime: "Departure time",
      deliveryOptions: "Delivery options",
      includeFirstMile: "Pickup from home to bus station",
      includeLastMile: "Delivery from bus station to recipient",
      // Warnings
      bothSelfService: "You must bring the package to the departure station and the recipient must pick it up from the arrival station.",
      firstMileSelfService: "You must bring the package to the departure station yourself.",
      lastMileSelfService: "The recipient must pick up the package from the arrival station.",
      // Step labels
      selfService: "Self",
      selfTransport: "Own transport",
      carTransport: "Car transport",
      busTrip: "Bus trip",
      // Summary
      distance: "Distance",
      duration: "Duration",
      price: "Price",
      routeSteps: "Route steps",
      priceBreakdown: "Price breakdown",
      departure: "Departure",
      arrival: "Arrival",
      // Actions
      select: "Select bus package",
      // Errors
      fetchError: "Could not fetch bus connections",
      generalError: "Error fetching bus options"
    }
  },
  processing: 'Processing...',
  // en.json
  "storefront": {
    "joined": "Joined",
    "userNotFound": "User not found",
    "listings": "listings",
    "noListings": "No listings found",
    "searchProducts": "Search products...",
    "noSearchResults": "No search results"
  },
  journeys: {
    origin: 'Origin',
    destination: 'Destination',
    today: 'Today',
    journeyGroups: 'journeys',
    noTicketsFound: 'No tickets found',
    searchNewTickets: 'Search for new',
    saveSearchAlert: 'Save search alert',
    searchForRoute: 'Search for this route',
    searching: 'Searching...',
    ticketsFound: '{{count}} tickets found',
    selectDateTime: 'Date & Time',
    clear: 'Clear',
    cancel: 'Cancel',
    apply: 'Apply',
    columns: {
      date: 'Date',
      time: 'Time',
      transportType: 'Transport type',
      passengerType: 'Passenger type',
      price: 'Price'
    },
    discover: {
      popularOrigins: 'Popular departures',
      destinationsFrom: 'Where from here?',
      routes: 'routes'
    },
    filters: {
      origin: 'Origin',
      destination: 'Destination',
      date: 'Date',
      time: 'Time',
      transportType: 'Transport type',
      passengerType: 'Passenger type',
      ticketType: 'Ticket type',
      "location": {
        "any": "Anywhere"
      },
      "category": {
        "any": "All categories"
      },
      "delivery": {
        "any": "Any speed"
      }
    },
    transportType: {
      train: 'Train',
      bus: 'Bus',
      plane: 'Plane',
      flight: 'Flight',
      carpool: 'Carpool',
      ferry: "Ferry",
      other: "Other"
    },
    passengerType: {
      adult: 'Adult',
      student: 'Student',
      child: 'Child',
      senior: 'Senior',
      pensioner: 'Pensioner'
    },
    errors: {
      required: 'Required field',
      searchFailed: 'Search failed. Please try again.',
      requiredFields: 'Origin, destination, and date are required'
    }
  }
};
